import {useEffect, useState} from "react";

import MissionsView from "./MissionsView";
import LoadingResult from "../management-lib/util/LoadingResult";
import DataProvider from "../management-lib/util/DataProvider";

export default function () {
    const [missions, setMissions] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = function () {
        new DataProvider("mission").custom("active").then(data => {
            console.log(data);
            setMissions(data);
            setLoading(false);
        });
    }

    useEffect(() => {
        load();
    }, [])

    if (loading) {
        return <LoadingResult border={false}/>
    }

    return (
        <MissionsView title="Active Missions" missions={missions}/>
    )
}